import Const = require("./utils/const");
import EventTypes = Const.EventTypes;

export class ZanLengthCalc {

    constructor() {
        this.setByClassName();
    }

    setByClassName(className: string = "zan-length-calc"): void {
        const elms = document.getElementsByClassName(className);
        Array.prototype.forEach.call(elms, (elm) => {

            if (!elm.dataset.zanLengthMax || !elm.dataset.zanIndicatorId)
                return;

            elm.addEventListener(
                Const.EventTypes.KEY_UP,
                (evt) => {
                    this.doCalc(evt.target);
                },
                false);

            this.doCalc(elm);
        });
    }

    private doCalc(elm:HTMLElement): void {
        if (!elm.dataset.zanLengthMax && !elm.dataset.zanIndicatorId)
            return;

        let zan = 0;
        if (elm as HTMLTextAreaElement) {
            const e = elm as HTMLTextAreaElement;
            zan = Number(e.dataset.zanLengthMax) - (e.value.length);
        }

        if (elm.dataset.zanIndicatorId) {
            const ind = document.getElementById(elm.dataset.zanIndicatorId) as HTMLElement;
            ind.textContent = `${zan.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
        }
    }
}
